import Rails from "@rails/ujs";
import {
  setError,
  clearErrors,
  setGlobalError,
  validate,
  clearGlobalErrors
} from "./validate";

window.Rails = Rails;

window.addEventListener("DOMContentLoaded", event => {
  if (!window._rails_loaded) Rails.start();
  const forms = document.querySelectorAll("form[data-remote]");
  for (var i = 0; i < forms.length; i++) {
    const form = forms[i];

    form.setAttribute("novalidate", true);

    form.addEventListener("ajax:before", event => {
      clearGlobalErrors();
      const form = event.target;
      const containers = form.querySelectorAll(".input-container");
      for (var c = 0; c < containers.length; c++) {
        validate(containers[c]);
      }

      if (form.querySelector(".error")) {
        event.preventDefault();
      }
    });

    form.addEventListener("ajax:send", event => {
      const form = event.target;
      const btn = form.querySelector("button");
      btn.disabled = true;
    });

    form.addEventListener("ajax:complete", event => {
      const form = event.target;
      const btn = form.querySelector("button");
      btn.disabled = false;
    });

    form.addEventListener("ajax:error", ({ detail }) => {
      if (!detail) return;

      try {
        const parsed = JSON.parse(detail[2].responseText);
        const errorsObj = parsed.errors || parsed.field_errors;

        if (errorsObj) {
          const errors = Object.entries(errorsObj);
          for (var e = 0; e < errors.length; e++) {
            const [field, messages] = errors[e];

            const container = form.querySelector(
              `.input-container[data-field="${field}"]`
            );

            if (!container) {
              const message = messages
                ? messages[0]
                : "An unknown error occurred.";
              setGlobalError(message);
              return;
            }

            clearErrors(container);
            for (var m = 0; m < messages.length; m++) {
              setError(container, messages[m]);
            }
          }
        } else {
          setGlobalError(error.message);
        }
      } catch {}
    });

    form.addEventListener("ajax:success", () => {
      window.top.postMessage("success", window.PERMITTED_HOST);
    });
  }
});
